<template>
  <div class="select-area">
    <div class="niche-area" v-if="list && list.length > 0">
      <div ref="nicheBox" class="niche-box">
        <div class="niche-list">
          <div class="niche-row" v-for="(r, i) in list" :key="i">
            <div
              class="niche-item"
              :class="{
                'niche-select':
                  n.selected || (n.id && nicheId && n.id == nicheId),
                'niche-not-selected': !selected,
                'niche-hidden': n.hidden,
                'niche-disabled': n.disabled,
              }"
              :style="itemStyle"
              @click="selectNiche(n)"
              v-for="(n, j) in r"
              :key="j"
              :ref="`niche-${n.row}-${n.cols}`"
            >
              <img
                :src="tabletIcon.img"
                class="niche-icon"
                v-if="tabletIcon?.img"
              />
              <div class="niche-img" v-else></div>
              <div class="niche-num">{{ n.num }}</div>
              <div class="niche-tip" v-if="n.disabled || !!n.tabletStatus">
                {{ n.tabletStatus ? "已供" : "禁用" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-empty
      description="暂无龛位"
      :image="emptyImage"
      class="empty-box"
      v-else-if="list"
    ></a-empty>
    <div class="niche-loading" v-show="loading">
      <a-spin />
    </div>
    <div
      class="action-box flex-box vertical"
      v-if="action && list && list.length > 0"
    >
      <a-popover placement="left">
        <template slot="content"> 1.CTRL键+滚轮缩放 2.长按点击平移 </template>
        <a-icon type="question-circle" class="question-btn btn" />
      </a-popover>
      <a-icon type="plus-square" class="btn" @click="zoom('big')" />
      <a-icon type="minus-square" class="btn" @click="zoom('small')" />
      <a-icon type="interaction" class="btn" @click="reset" />
    </div>
  </div>
</template>

<script>
// import { clone } from "../../../common/js/tool";
import Panzoom from "@panzoom/panzoom";
import { Empty } from "ant-design-vue";

export default {
  name: "BlockArea",
  props: {
    value: { type: Number }, // 佛龛id
    single: { type: Boolean, default: false }, // 单选
    action: { type: Boolean, default: true }, // 可操作放大缩小
    loading: Boolean,
    list: Array, // 龛位列表
    tabletIcon: Object, // 图标
    selected: { type: Boolean, default: true }, // 龛位是否可选
  },
  data() {
    return {
      scale: 1,
      panzooming: false,
      panzoom: null,
      emptyImage: Empty.PRESENTED_IMAGE_SIMPLE,
    };
  },
  computed: {
    itemStyle() {
      return this.panzooming
        ? { pointerEvents: "none" }
        : { pointerEvents: "auto" };
    },
    nicheId: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    list(val) {
      if (val.length > 0) {
        this.$nextTick(() => {
          this.listenEvent();
        });
      }
    },
  },
  methods: {
    listenEvent() {
      const nicheBox = this.$refs.nicheBox;
      if (!nicheBox) return;
      const panzoom = Panzoom(nicheBox, {
        minScale: 0.2,
        maxScale: 5,
      });
      nicheBox.addEventListener("wheel", (e) => {
        if (!e.ctrlKey) return;
        e.preventDefault();
        panzoom.zoomWithWheel(e);
      });
      nicheBox.addEventListener("panzoomchange", () => {
        this.panzooming = true;
      });
      nicheBox.addEventListener("panzoomend", () => {
        this.panzooming = false;
      });
      this.panzoom = panzoom;
    },
    // 选择龛位
    selectNiche(n) {
      // 不能选择 | 占位隐藏 | 禁用 | 已供奉
      if (!this.selected || n.hidden || n.disabled) return;
      if (this.single) {
        if (this.nicheId == n.id) {
          this.nicheId = undefined;
        } else {
          this.nicheId = n.id;
        }
      } else {
        this.$set(n, "selected", !n.selected);
      }
    },

    // 放大缩小
    zoom(type) {
      if (!this.panzoom) return;
      if (type == "big") {
        this.panzoom.zoomIn();
      } else if (type == "small") {
        this.panzoom.zoomOut();
      }
    },
    // 重置
    reset() {
      if (!this.panzoom) return;
      this.panzoom.reset();
    },
  },
};
</script>

<style lang="less">
.area-block {
  position: absolute;
  z-index: 10;
  background-color: #f2ecec;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #000;
  font-size: 28px;
  line-height: 32px;
  overflow: hidden;
  cursor: default;
}
</style>
<style lang="less" scoped>
.select-area {
  position: relative;
  display: flex;
  width: 100%;
}
.niche-area {
  position: relative;
  overflow: auto;
  width: 100%;
  padding: 6px;
}
.niche-box {
  position: relative;
  width: 100%;
  height: 100%;
}
.niche-list {
  width: max-content;
}
.niche-row {
  display: flex;
  &:not(:first-of-type) {
    margin-top: 6px;
  }
}
.niche-item {
  position: relative;
  z-index: 2;
  padding: 4px;
  cursor: pointer;
  &:not(:first-of-type) {
    margin-left: 6px;
  }
  &.niche-not-selected {
    cursor: default;
  }
  &.niche-disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &.niche-hidden {
    opacity: 0;
  }
  &.niche-select {
    position: relative;
    z-index: 20;
    .niche-img {
      background-image: url(../../../assets/light/niche-select.png);
    }
    .niche-num {
      color: #fff;
      background-color: #ff8c00;
      border-radius: 4px;
      height: 18px;
      line-height: 18px;
      margin-top: 2px;
    }
    .niche-icon {
      opacity: 1;
    }
    .niche-tip {
      color: #fff;
    }
  }
}
.niche-tip {
  position: absolute;
  left: 50%;
  top: 20px;
  transform: translateX(-50%);
  z-index: 1;
  font-size: 12px;
}
.niche-num {
  text-align: center;
}
.niche-img {
  width: 40px;
  height: 45px;
  background: url(../../../assets/light/niche.png) center / contain no-repeat;
}
.niche-icon {
  width: 40px;
  height: 45px;
  object-fit: contain;
}
.niche-border {
  opacity: 0;
  position: absolute;
  background-color: #ffc566;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.4);
  z-index: 1;
}
.action-box {
  position: absolute;
  right: 20px;
  top: 80px;
  z-index: 20;
  background-color: #fff;
  box-shadow: 0 0 6px #f2ecec;
  padding: 2px;
  .btn {
    font-size: 32px;
    cursor: pointer;
    &.question-btn {
      font-size: 30px;
      margin-bottom: 6px;
    }
  }
}
.empty-box {
  margin: 48px auto 0;
}
.niche-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
